module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="430.113" height="430.114" viewBox="0 0 430.113 430.114"><path d="M158.081 83.3v59.218h-43.385v72.412h43.385v215.183h89.122V214.936h59.805s5.601-34.721 8.316-72.685H247.54V92.74c0-7.4 9.717-17.354 19.321-17.354h48.557V.001h-66.021C155.878-.004 158.081 72.48 158.081 83.3z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/facebook.svg
// module id = 517
// module chunks = 1